import { useQuery } from '@tanstack/react-query';
import { getApplicationGuidelineById } from 'api/auth.api';

export const useApplicationGuidelineById = (id) => {
  return useQuery({
    queryKey: ['applicationGuidelineById', id],
    queryFn: () => getApplicationGuidelineById(id),
    enabled: !!id,
  });
};
